<template>
    <project-step-container
            prev-to="be_go_broad_to_go_narrow_12"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="pb-5">
            <b-col cols="12" class=" simple-text" tabindex="0">
                {{getMessage(13, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>
        <LinkStyleGuide @open-url="openGuide100Narrowing" icon-name="icon-guide" :text="getMessage(13, 'gobroadtogonarrow-guide')" ></LinkStyleGuide>
        <br>
        <LinkStyleGuide @open-url="openGuide2By2Narrowing" icon-name="icon-guide" :text="getMessage(13, 'gobroadtogonarrow-guide-2')" ></LinkStyleGuide>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {Steps} from "@/modules/BeEntrepreneurship/Utils";

    export default {
        name: "GoBroadToGoNarrow13",
        components: {ProjectStepContainer , LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step:Steps.FORM_BROAD_NARROW_GOING,
                styleGuide: {}
            }
        },
        methods: {
            openGuide100Narrowing() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.POINTS_NARROWING)
                this.$bvModal.show('project-style-guide')
            },
            openGuide2By2Narrowing() {
                this.styleGuide = StyleGuides.getStyleGuide(StyleGuides.NARROWING)
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'be_go_broad_to_go_narrow_14', params: {index}})
            }
        }
    }
</script>

